import { gql } from "@apollo/client";

export default gql`
  query orders($first: Int!, $after: String) {
    viewer {
      me {
        name(format: FIRST_NAME_LAST_NAME)
        id
      }
    }
    ordersConnection: ordersToBeArtworkReviewed(first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          id
        }
      }
    }
  }
`;
